export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true
    },
    {
        id: 2,
        label: "menuitems.dashboards.text",
        icon: "bx-home-circle",
        badge: {
            variant: "info",
            text: "menuitems.dashboards.badge"
        },
        subItems: [
            {
                id: 3,
                label: "Dashboard",
                link: "/",
                parentId: 2
            },
            {
                id: 5,
                label: "Account",
                link: "/account",
                parentId: 2
            }
        ]
    },
    {
        id: 281,
        label: "Master",
        icon: "bx-store",
        subItems: [
            {
                id: 1001,
                label: "Voucher",
                link: "/voucher",
                parentId: 281
            },
        ]
    },
];

